import brickTypes from './brick-types';
import { initialize as initializeAudienceFilterBrick } from "./audience-filter-brick";
import { initialize as initializeTouchpointBrick } from './touchpoint-brick';
import { initialize as initializeABTestBrick } from './ab-test-brick';
import { initialize as initializeGoalBrick } from './goal-brick';
import { initialize as initializeJourneyBrick } from './journey-brick';
import { withUnconnectedRegularConnectionAtAllTimes } from './brick-initializer-helpers';


export default {
    [brickTypes.audienceFilter]: initializeAudienceFilterBrick,
    [brickTypes.abTest]: initializeABTestBrick,
    [brickTypes.touchpoint]: initializeTouchpointBrick,
    [brickTypes.goal]: initializeGoalBrick,
    [brickTypes.journey]: initializeJourneyBrick,
    
    [brickTypes.audience]: brick => withUnconnectedRegularConnectionAtAllTimes(brick)
};